document.addEventListener("DOMContentLoaded", function() {
    // 1. Apanhar todas as secções
    const sections = document.querySelectorAll('.timeline-group-container');

    if (sections.length === 0) return;

    // 2. Guardar referências
    const parallaxItems = [];

    sections.forEach(section => {
        const overlayItem = section.querySelector('.timeline-imagem-container.image-overlay.has-parallax');
        
        if (overlayItem) {
            parallaxItems.push({
                container: section,
                item: overlayItem
            });
        }
    });

    if (parallaxItems.length === 0) return;

    // 3. Função de atualização
    function updateAllOverlays() {
        const viewportHeight = window.innerHeight;

        parallaxItems.forEach(obj => {
            const sectionOverlay = obj.container;
            const overlayItem = obj.item;

            const rect = sectionOverlay.getBoundingClientRect();

            // Se não estiver visível, ignora
            if (rect.bottom < 0 || rect.top > viewportHeight) return;

            // --- A TUA NOVA LÓGICA MATEMÁTICA ---
            
            // 1. Calcular a percentagem de scroll (de 0 a 1)
            // 0 = O topo da secção acabou de entrar em baixo do ecrã
            // 1 = O fundo da secção acabou de sair por cima do ecrã
            let scrollProgress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
            
            // (Opcional) Garantir que fica entre 0 e 1, caso haja saltos bruscos
            // scrollProgress = Math.max(0, Math.min(1, scrollProgress));

            // 2. Definir o limite máximo (150px)
            const maxDistance = 150; 

            // 3. Calcular o movimento
            // Multiplicamos por -1 porque em CSS "subir" significa valores negativos (translateY negativo)
            // Resultado: Começa em 0 e vai até -150px
            const moveY = scrollProgress * maxDistance * -1; 

            overlayItem.style.setProperty('--overlay-y', `${moveY}px`);
        });
    }

    // 4. Listener de Scroll
    let ticking = false;
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateAllOverlays();
                ticking = false;
            });
            ticking = true;
        }
    });

    updateAllOverlays();
});

// Forcefully hide native video controls on mobile devices
document.addEventListener("DOMContentLoaded", function() {
    // Only run on mobile devices
    if (window.matchMedia('(max-width: 749px)').matches || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
        // Function to remove controls from all videos
        function removeVideoControls() {
            const videos = document.querySelectorAll('video');
            videos.forEach(video => {
                // Remove controls attribute
                video.removeAttribute('controls');
                video.controls = false;
                
                // Ensure playsinline is set
                if (!video.hasAttribute('playsinline')) {
                    video.setAttribute('playsinline', '');
                }
            });
        }
        
        // Run immediately
        removeVideoControls();
        
        // Run again after a short delay to catch dynamically loaded videos
        setTimeout(removeVideoControls, 1000);
        setTimeout(removeVideoControls, 3000);
        
        // Also run when deferred media loads
        document.addEventListener('click', function(e) {
            if (e.target.closest('[on\\:click="/showDeferredMedia"]')) {
                setTimeout(removeVideoControls, 500);
            }
        });
    }
});